export const formatSSN = (value) => {
  let val = value.replace(/\D/g, '');
  let newVal = '';
  if (val.length > 3 && val.length < 6) {
    newVal += `${val.substr(0, 3)}-`;
    val = val.substr(3);
  }
  if (val.length > 5) {
    newVal += `${val.substr(0, 3)}-`;
    newVal += `${val.substr(3, 2)}-`;
    val = val.substr(5);
  }
  newVal += val;
  return newVal;
};

export const formatPhoneNumber = (value) => {
  let val = value.replace(/\D/g, '');
  let areaCode = '';
  let middle3 = '';
  let last4 = '';

  if (val.length > 0) {
    areaCode = val.substr(0, 3);
    middle3 = val.substr(3, 3);
    last4 = val.substr(6, 4);
    if (val.length > 6) {
      val = `(${areaCode}) ${middle3}-${last4}`;
    } else if (val.length > 3) {
      val = `(${areaCode}) ${middle3}`;
    }
  }
  return val;
};

export const formatDate = (value) => {
  let val = value.replace(/\D/g, '');
  let newVal = '';
  if (val.length > 2 && val.length < 5) {
    newVal += `${val.substr(0, 2)}/`;
    val = val.substr(2);
  }
  if (val.length > 4) {
    newVal += `${val.substr(0, 2)}/`;
    newVal += `${val.substr(2, 2)}/`;
    val = val.substr(4);
  }
  newVal += val;
  return newVal;
};

export const isFutureDate = (iDate) => {
  const today = new Date().getTime();
  const iDate1 = iDate.split('/');
  const iDate2 = new Date(iDate1[2], iDate1[1] - 1, iDate1[0]).getTime();
  return (today - iDate2) < 0;
};

export const fireGoogleAnalyticsPageView = (pageViewed) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'trackVirtualPageview',
    virtualPageview: `${window.location.pathname}/${pageViewed}`,
  });
};

export const fireGoogleAnalyticsApiResponseEvent = (
  apiName,
  responseTimeMs,
) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'trackEvent',
    eventCategory: 'ui-employee-registration-login',
    eventAction: 'API Response Time',
    eventLabel: apiName,
    eventValue: responseTimeMs,
  });
};
